export function getNumberShorts(num: number): string {
  if (num < 1000) {
    return num.toString();
  }
  if (num < 1000000) {
    return `${Intl.NumberFormat('en', { notation: 'compact' }).format(num / 1000)}K`;
  }
  return `${Intl.NumberFormat('en', { notation: 'compact' }).format(num / 1000000)}M`;
}
